// Reference: https://www.youtube.com/watch?v=yAI9fbbH-rM
// https://apexcharts.com/react-chart-demos/column-charts/stacked-columns-100/

import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useTheme } from '../../../../contexts/ThemeContext'

const ApexDBColumnChart = ({ data, title, height }) => {
  const { theme } = useTheme()
  const [chartData, setChartData] = useState()

  useEffect(() => {
    if (theme === 'dark') {
      renderChart('#d1d5db')
    } else if (theme === 'light') {
      renderChart('#6b7280')
    }
  }, [theme, data])

  function renderChart(labelColor) {
    setChartData({
      series: data || [
        {
          name: 'Scope 1',
          data: [10, 12, 90, 44, 55, 57, 56, 61, 58, 63, 60, 66],
          color: '#F89C74'
        },
        {
          name: 'Scope 2',
          data: [20, 40, 50, 76, 85, 101, 98, 87, 105, 91, 114, 94],
          color: '#66C5CC'
        },
        {
          name: 'Scope 3',
          data: [56, 22, 12, 35, 41, 36, 26, 45, 48, 52, 53, 41],
          color: '#8BE0A4'
        },
      ],
      options: {
        chart: {
          fontFamily: 'DM Sans, sans-serif',
          stacked: true,
          toolbar: {
            show: false
          },
          stackType: undefined
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '80%',
            endingShape: 'rounded',
          },
        },
        legend: {
          show: true,
          position: 'right',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '14px',
          fontFamily: 'Inter',
          fontWeight: 400,
          labels: {
            // colors: '#9ca3af',
            colors: labelColor,
            useSeriesColors: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        colors: ['#F89C74', '#66C5CC', '#8BE0A4', '#DCB0F2', '#F6CF71'],
        xaxis: {
          title: {
            text: 'Months',
            style: {
              color: labelColor,
              fontWeight: '500',
              fontSize: '12px',
            },
          },
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          labels: {
            style: {
              colors: labelColor,
            },
          },
        },
        yaxis: {
          title: {
            text: 'Tonnes of CO2',
            style: {
              color: labelColor,
              fontWeight: '500',
              fontSize: '14px',
            },
          },
          labels: {
            style: {
              colors: labelColor,
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return +val + ' kg CO2'
            },
          },
        },
      },
    })
  }

  return (
    <div className="overflow-hidden sm:rounded-lg bg-white dark:bg-darkbg4 px-4 py-6 border">
      <h3 className="text-left px-6">
        {title}
      </h3>
      {chartData && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={height}
        />
      )}
    </div>
  )
}

export default ApexDBColumnChart
